import { render } from "./DataAccessRibbon.vue?vue&type=template&id=eca8fcf0"
import script from "./DataAccessRibbon.vue?vue&type=script&lang=js"
export * from "./DataAccessRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__